import { render, staticRenderFns } from "./select_hospital.vue?vue&type=template&id=61a710bc&scoped=true&"
import script from "./select_hospital.vue?vue&type=script&lang=js&"
export * from "./select_hospital.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./select_hospital.vue?vue&type=style&index=1&id=61a710bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a710bc",
  null
  
)

export default component.exports